const AdminUsers = () => {
  return (
    <div className="container-custom section-padding">
      <h1 className="text-3xl font-bold mb-8">Manage Users</h1>
      <div className="bg-white p-8 rounded-lg shadow-md">
        <p className="text-gray-600">User management coming soon...</p>
      </div>
    </div>
  )
}

export default AdminUsers
